import React, { Fragment } from "react"
import classNames from "classnames"
import styles from "./utils/elements.module.scss"

const SlidingModal = (props) => {
  return (
    <div
      className={classNames("modal", {
        "is-active": props.isModalActive,
      })}
    >
      <div
        className={`modal-background has-background-${props.modalBackground?.color} has-opacity-${props.modalBackground?.opacity}`}
        onClick={props.closeModal}
      ></div>
      <SlidingModalCardBody {...props} />
    </div>
  )
}

const SlidingModalCardBody = (props) => {
  return (
    <div
      className={classNames(
        "modal-card p-0",
        { [styles["slidingModal__cardIsActive"]]: props.isModalActive },
        { [styles["slidingModal__cardIsClosed"]]: props.isModalClosed }
      )}
    >
      {props.heading && (
        <div
          className={classNames(
            "modal-card-head",
            props.modalHeaderClass,
            {
              "has-background-white": !props.modalHeaderClass,
            },
            {
              [styles["slidingModal__cardHeaderFullheight"]]:
                props.isFullheight,
            }
          )}
        >
          <p className={classNames("modal-card-title", props.modalHeaderClass)}>
            {props.heading}
          </p>
        </div>
      )}
      <div
        className={classNames(
          "modal-card-body has-text-centered",
          styles["slidingModal__cardBody"]
        )}
      >
        <div
          className={classNames(styles["slidingModal__closingBar"])}
          onClick={props.closeModal}
        ></div>
        {props.children}
      </div>
    </div>
  )
}

export default SlidingModal
